import React, { useContext, useEffect, useState } from "react";
import { Container } from "@mui/material";
import { useLocation } from "react-router-dom";
import useFetchStripeTransaction from "./hook/useFetchStripeTransaction";

import { unixToDateConversion } from "utils/helpers/unixToDateConversion";
import { StyledMainPageContainer, StyledSectionBackgroundWrapper } from "index.styles";
import CBLoading from "components/CBLoading";
// import { StyledButtonContainer } from "index.styles";
import MKButton from "components/MKButton";
import { CartContext } from "utils/context/cart.context";
import PageHeader from "components/CBPageHeader";
import OrderConfirmationSummary from "./components/orderConfirmationSummary";
import CBDivider from "components/CBDivider";
import AdditionalInformation from "./components/addtionalInformation";

const OrderConfirmation = () => {
  const location = useLocation();
  const { subscriptionPaymentIntentId } = location.state;
  const { clearCart } = useContext(CartContext);
  const { data: subscriptionPaymentIntent, loading, error } = useFetchStripeTransaction(subscriptionPaymentIntentId);
  const [hasCleared, setHasCleared] = useState(false);

  useEffect(() => {
    if (subscriptionPaymentIntent && !hasCleared) {
      clearCart();
      setHasCleared(true);
    }
  }, [subscriptionPaymentIntent, hasCleared, clearCart]);

  if (loading) {
    return (
      <Container sx={{ marginBlock: "4rem" }}>
        <CBLoading loadingItem={"order confirmation"} />
      </Container>
    );
  }

  if (error) {
    return <Container sx={{ marginBlock: "4rem" }}>{error}</Container>;
  }

  // Check if this is a healing center subscription
  const isEHRcheckout =
    subscriptionPaymentIntent?.metadata?.userType === "healing center" ||
    subscriptionPaymentIntent?.metadata?.userType === "facilitator" ||
    subscriptionPaymentIntent.isTrial === true;

  if (isEHRcheckout) {
    // Simplified EHR confirmation for healing centers
    return (
      <StyledMainPageContainer id="ehr-order-confirmation-container">
        <StyledSectionBackgroundWrapper
          sx={{
            background: "#ffffff !important",
            backgroundImage: "none !important",
            padding: "3rem 1rem !important",
            minHeight: "50vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <PageHeader
            lightText={false}
            header="Your subscription is now active!"
            headerAccent="active!"
            content={
              <span>
                Please check your email to being your onboarding journey. This email can take up to 3 minutes to reach your inbox.{" "}
                <span style={{ color: "#09ABA8" }}>-</span>
                <span style={{ color: "#F77C3a" }}>support@almadelic.com</span>
              </span>
            }
            sx={{
              "& .MuiTypography-h1": {
                color: "#09ABA8 !important",
                fontWeight: "600 !important",
                lineHeight: "1.4 !important",
                fontSize: { xs: "1.75rem", sm: "2.25rem", md: "2.5rem" },
                marginBottom: "1.5rem !important",
              },
              "& .MuiTypography-h1 span": {
                color: "#09ABA8 !important",
              },
              "& p": {
                color: "#333333 !important",
                fontSize: { xs: "1.125rem", sm: "1.25rem" },
                lineHeight: "1.6 !important",
                fontWeight: "400 !important",
                maxWidth: "700px",
                margin: "0 auto",
              },
              '& p span[style*="color"]': {
                color: "#F77C3a !important",
              },
            }}
          />
        </StyledSectionBackgroundWrapper>
      </StyledMainPageContainer>
    );
  }

  // Standard order confirmation for other user types
  const address = JSON.parse(subscriptionPaymentIntent?.metadata.billingAddress).state.toLowerCase();
  const clinicalEvaluationLink =
    address === "colorado" || address === "co"
      ? "https://clinical.almadelic.com/get-started-clinical-evaluation-colorado"
      : address === "ohio" || address === "oh"
      ? "https://clinical.almadelic.com/get-started-clinical-evaluation-ohio"
      : address === "florida" || address === "fl"
      ? "https://clinical.almadelic.com/get-started-clinical-evaluation-florida"
      : "https://clinical.almadelic.com/get-started-clinical-evaluation";

  return (
    <StyledMainPageContainer id="ehr-order-confirmation-container">
      <StyledSectionBackgroundWrapper>
        <PageHeader
          lightText={true}
          header="Thank you for your order! \n What's next?"
          headerAccent="What's next?"
          content="The next critical step is to schedule your Initial Clinical Evaluation. This 45-minute appointment with a licensed mental health specialist is key to tailoring your therapy to your unique needs."
          cta={
            <MKButton href={clinicalEvaluationLink} variant="contained" color="secondary" size="large" align="center">
              Schedule Your Clinical Evaluation
            </MKButton>
          }
        />
      </StyledSectionBackgroundWrapper>
      <OrderConfirmationSummary
        firstName={subscriptionPaymentIntent?.metadata.firstName}
        lastName={subscriptionPaymentIntent?.metadata.lastName}
        billingAddress={subscriptionPaymentIntent?.metadata.billingAddress}
        shippingAddress={subscriptionPaymentIntent?.metadata.shippingAddress}
        phone={subscriptionPaymentIntent?.metadata.phone}
        email={subscriptionPaymentIntent?.metadata.email}
        orderId={subscriptionPaymentIntent?.id}
        discount={subscriptionPaymentIntent?.metadata.couponAmount}
        couponId={subscriptionPaymentIntent?.metadata.couponId}
        originalSubtotal={subscriptionPaymentIntent?.metadata.subtotal}
        cartTotal={subscriptionPaymentIntent?.amount}
        createdAt={unixToDateConversion(subscriptionPaymentIntent?.createdAt || subscriptionPaymentIntent?.created)}
        paymentId={subscriptionPaymentIntent?.id}
        paymentMethod={subscriptionPaymentIntent?.payment_method_types}
        cartItems={subscriptionPaymentIntent?.metadata.cartItems}
        nextPayment={subscriptionPaymentIntent?.metadata?.nextPaymentAmount}
        isEhrSubscription={true}
      />
      <CBDivider />
      <AdditionalInformation />
    </StyledMainPageContainer>
  );
};

export default OrderConfirmation;
